module.exports = __webpack_public_path__ + "img/paper-plane.df7091a3.png";